export interface IKycPerson {
  firstName: string;
  middleName?: string;
  lastName: string;
  birthdate: string;
  email: string;
}

export interface IKycStartRequest {
  person: IKycPerson;
}

export type KycStatus = 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'ACCEPTED' | 'DISCARDED' | 'CANCELLED' | 'EXPIRED';

export const KYC_POLLING_STATUSES: readonly KycStatus[] = ['PENDING', 'PROCESSING', 'COMPLETED'];
export const KYC_FAILURE_STATUSES: readonly KycStatus[] = ['DISCARDED', 'CANCELLED', 'EXPIRED'];
export const KYC_STATUS_ACCEPTED: KycStatus = 'ACCEPTED';
export const KYC_MAX_START_ATTEMPTS = 3;
export const KYC_STATUS_POLL_INTERVAL_MS = 8000;
export const KYC_MAX_POLL_ERRORS = 3;

export type KycResult = 'verified' | 'unverified' | null;

export interface IKycStartResponse {
  status: KycStatus;
  result: KycResult;
  url: string;
}

export interface IKycStatusResponse {
  processStatus: KycStatus;
  result: KycResult;
}
